import React from 'react';
import { PubSub } from '../pubsub';
import { assign } from 'lodash';

const channel = new PubSub('pubsub_login_error');
window.lchannel = window.lchannel || channel;

class HTTPError extends React.Component {

  constructor(props) {
    super(props);
    // список начальных состояний
    this.defState = {};
    let state = this.defState;
    // сливаем с this.props  и  пропускаем через serializer
    assign(state, this.props);
    this.state = this.serializer(state);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let state = this.defState;
    // сливаем с this.props  и  пропускаем через serializer
    assign(state, nextProps);
    this.setState(this.serializer(state));
  }

  serializer(props) {
    let code = parseInt(props.params.code, 10);
    let errorText = apiAdapter.getTranslation("ConnectionError", "errors");
    if (code === 404) {
      errorText = apiAdapter.getTranslation("404_NotFound", "errors");
    } else if (code === 401) {
      errorText = apiAdapter.getTranslation("idleTimeout", "errors");
    } else if (code === 403) {
      errorText = apiAdapter.getTranslation("403_Forbidden", "errors");
    } else if (code === 400) {
      errorText = apiAdapter.getTranslation("400_BadRequest", "errors");
    } else if (code === 456) {
      errorText = apiAdapter.getTranslation("456_Uncorrectable", "errors");
    } else if (code === 500) {
      errorText = apiAdapter.getTranslation("500_InternalServerError", "errors");
    } else if (code === 503) {
      errorText = apiAdapter.getTranslation("503_ServiceUnavailable", "errors");
      // специальные коды
    } else if (code === 10) {
      errorText = apiAdapter.getTranslation("SessionHasExpired", "errors");
    }
    props.params.text = errorText;
    channel.publish({
      type: 'LoginError',
      params: {
        errorCode: '500',
        errors_text: errorText
      }
    });
    return props;
  }

  send(e) {
    e.preventDefault(); //Отменили нативное действие
    (e.cancelBubble) ? e.cancelBubble : e.stopPropagation; //Погасили всплытие
    // перегружаем виджет
    location.href = location.href;
    return false;
  }

  render() {
    return (<div className="welcome__login js-loader">
      <div className="welcome__login-box">
        <h3 className="welcome__login-title-red">Произошла ошибка</h3>
        {(this.state.params.code != 0 && this.state.params.code != 10 && this.state.params.code != 1000) ? (<div className="welcome__login-e_code"> Код ошибки: {this.state.params.code}</div>) : ""}
        <div className="welcome__login-e_desc">{this.state.params.text}</div>
        <a className="welcome__login-action" href="#" onClick={(e) => this.send(e, this)}>Попробовать ещё раз</a>
      </div>
    </div>);
  }
}

export default HTTPError;
